import styled from 'styled-components';

export const OpenedImgWrapper = styled.div`
  display: flex;
  max-width: 80vw;
  max-height: 70vh;
  width: 100%;
  background: black;
  justify-content: center;
  align-items: center;
`;

export const PreviewImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const OpenedImg = styled.img`
  object-fit: contain;
  max-width: 80vw;
  max-height: 70vh;
  width: 100%;
  height: 100%;
`;
